import { Navigate, Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import { adminMe, getToken, clearToken } from "@/lib/api";

export default function ProtectedRoute() {
  const [state, setState] = useState("checking"); // checking | ok | unauth

  useEffect(() => {
    if (!getToken()) {
      setState("unauth");
      return;
    }
    adminMe()
      .then(() => setState("ok"))
      .catch(() => {
        clearToken();
        setState("unauth");
      });
  }, []);

  if (state === "checking") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-paper-50" data-testid="admin-loading">
        <p className="text-ink-muted text-sm">Checking session…</p>
      </div>
    );
  }
  if (state === "unauth") return <Navigate to="/admin/login" replace />;
  return <Outlet />;
}
